// Document types a partner can re-verify a single income with. Mirrors the API's
// Source::REVERIFY_TYPES: bank statements are excluded because their items are assigned to
// incomes in a separate step, so they cannot replace one income's verification on their own.
export enum DocType {
  Paystub = "paystub",
  W2 = "w2",
  BenefitsStatement = "benefits_statement"
}

export enum ReverifyFlows {
  SelectOption,
  ReVerifyWithDocuments,
  SendRequest
}

export enum VerificationType {
  Bank = "bank",
  Payroll = "payroll",
  Documents = "documents"
}
